<template>

  <Loader v-if="loader" />
    
      <div class="grid" v-if="estrattoConto">
        <div class="col-12" v-if="estrattoConto.used == 1">
          
            <div  class="card mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block text-500 font-medium mb-1 title-detail">IMPORTO</span>
                  <div class="text-900 font-medium text-xl">
                    <div class="importo">{{formatCurrency(estrattoConto.value.toFixed(2))}}
                      <span class="pi pi-euro"></span>
                    </div>
                  </div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                  <i class="pi pi-euro text-blue-500 text-xl"></i>
                </div>
              </div>
              <hr>
              <div class="grid">
                <div class="col-6">
                  <p class="block text-500 font-medium mb-1 title-detail"> DATA VALUTA</p>
                  <b>{{formatDate(estrattoConto.data_valuta)}}</b>
                </div>
                <div class="col-6">
                  <p class="block text-500 font-medium mb-1 title-detail">DATA CONTABILE</p>
                  <b>{{formatDate(estrattoConto.data_contabile)}}</b>
                </div>
                <div class="col-6">
                  <p class="block text-500 font-medium mb-1 title-detail">BANCA</p>
                  <b>{{estrattoConto.type_pay_mode_name}}</b>
                </div>
                <div class="col-6">
                  <p class="block text-500 font-medium mb-1 title-detail">TIPOLOGIA</p>
                  <b>{{estrattoConto.type_pay_name}}</b>
                </div>
                <div class="col-12">
                  <p class="block text-500 font-medium mb-1 title-detail">DESCRIZIONE</p>
                  <b>{{estrattoConto.descrizione}}</b>
                </div>
              </div>
              
            </div>
          

        <div class="mt-3" v-if="display">
          <div class="card">
            <div class="flex justify-content-between mb-3">
              <Button icon="pi pi-download" label="Esporta" @click="exportCSV($event)" class="p-button-outlined p-button-secondary" />
              <Button  @click="confirmDissociate" label="Dissocia pagamenti" class="p-button-secondary ml-2"  />
            </div>
            <div v-if="fatture.length > 0">
              <h4>Incassi clienti</h4>
              <DataTable ref="dt" :value="fatture" responsiveLayout="scroll" :rowClass="rowClass">
                  <Column field="numero" header="Numero"></Column>
                  <Column field="cliente" header="Cliente"></Column>
                  <Column field="value" header="Importo"></Column>
                  <Column field="data_insert" header="Data Inserimento"></Column>
                  <Column :exportable="false">
                      <template #body="{data}">
                          <Button  icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="openEditDialog(data)" />
                      </template>
                  </Column>
              </DataTable>
            </div>
            <div v-if="fornitori.length > 0">
              <h4>Pagamenti Fornitori</h4>
              <DataTable ref="dt" :value="fornitori" responsiveLayout="scroll">
                  <Column field="numero" header="Numero"></Column>
                  <Column field="fornitore" header="Fornitore"></Column>
                  <Column field="value" header="Importo"></Column>
                  <Column field="data_insert" header="Data Inserimento"></Column>
              </DataTable>
            </div>
            <div v-if="fatture.length == 0 && fornitori.length == 0">
              <div v-if="estrattoConto.from_cod_type_pay_mode > 0">
                <h4>Giroconto</h4>
                <div v-if="estrattoConto.value > 0">
                  Giroconto da {{estrattoConto.from_type_pay_mode_name}} a {{estrattoConto.type_pay_mode_name}}
                </div>
                <div v-else>
                  Giroconto da {{estrattoConto.type_pay_mode_name}} a {{estrattoConto.from_type_pay_mode_name}}
                </div>
              </div>
              <div v-else>
                <div v-if="estrattoConto.commercialista == 1">
                  <h4>Commercialista</h4>
                  Inviato e gestito dal commercialista
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>    
        <div v-else class="col-12">
          <div class="card warn-not-regularized bg-yellow-400 text-center">
            Questo movimento non è regolarizzato
          </div>
          <router-link :to="`/estratti-conto/detail/not-regularized/${estrattoConto.id}`"> 
              <Button label="Vai al movimento" icon="pi pi-arrow-left" iconPos="left" />
            </router-link>
        </div>
      </div>
      <div v-else class="card">
        <Skeleton class="mb-2"></Skeleton>
        <Skeleton width="100%" class="mb-2"></Skeleton>
        <Skeleton width="5rem" class="mb-2"></Skeleton>
        <Skeleton height="2rem" class="mb-2"></Skeleton>
        <Skeleton width="10rem" height="4rem"></Skeleton>
      </div>
      
    <!-- DIALOG Edit DISSOCIATE -->
    <Dialog v-model:visible="editDialog" :style="{width: '70vw'}" header="Sostituisci numero fattura" :modal="true">
        <div class="formgrid grid">
            <div class="field col-12 md:col-12">
                <label>Nuovo numero</label>
                <input v-model="newNumero" type="text" class="uppercase text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none  w-full">
                <small class="p-error" v-if="validationErrors.numero && submitted">Lunghezza numero troppo corta </small>
                <p class="mt-3">Il nuovo numero <span class="uppercase font-bold">{{newNumero}}</span> sostituirà quello esistente <span class="font-bold">{{oldPayment.numero}}</span></p> 
                <small>L'importo rimarrà invariato</small>
            </div>
        </div>
        <template #footer>
          <Button label="Chiudi" icon="pi pi-times" class="p-button-text" @click="editDialog = false"/>
          <Button label="Sostituisci" icon="pi pi-check" @click="substitute"/>
        </template>
    </Dialog>

    <!-- DIALOG Hard DISSOCIATE -->
    <Dialog v-model:visible="dissociateDialog" :style="{width: '500px'}" header="Conferma dissociazione" :modal="true">
        <div class="confirmation-content flex align-items-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem; color: #EF4444" />
            <div>
              Confermi la dissociazione di questo movimento da questi pagamenti ? <br>
              <div  class="mt-2 text-500">
                <small>I pagamenti associati saranno eliminati e dovranno essere associati nuovamente.</small>
              </div>
            </div>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="dissociateDialog = false"/>
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="dissociate" />
        </template>
    </Dialog>

</template> 

<script>

import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import {useRoute, useRouter} from 'vue-router';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'

export default {

    components: {
      Loader
    },
    setup() {
      const dt = ref();
      const loader = ref(false)
      const toast = useToast();
      const route = useRoute()
      const router = useRouter()
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const idEstrattoConto = route.params.id
      const estrattoConto = ref(null)
      const fatture = ref([])
      const fornitori = ref([])
      const display = ref(false)
      const dissociateDialog = ref(false);
      const editDialog = ref(false)
      const oldPayment = ref('')
      const newNumero = ref('')
      const submitted = ref(false);
      const validationErrors = ref({})
      

      onMounted(() => {
        getData()
      })

     
      const getData = () => {
        service.getEstrattoConto(idEstrattoConto).then((res) => {
          if (res.items.length) {
            estrattoConto.value = res.items[0]
            getInfo()
          } 
        })
      }

      const getInfo = async () => {
        service.getPaymentsAssociated(estrattoConto.value.id).then((res) => {
          fatture.value = res.items.fatture
          fornitori.value = res.items.fornitori
          display.value = true
        })
      }


      const confirmDissociate = () => {
        dissociateDialog.value = true;
      }

      const dissociate = () => {
        service.dissociateToPayments(estrattoConto.value, fatture.value, fornitori.value).then((res) => {
          if (res) {
            router.push({ path: `/estratti-conto/detail/not-regularized/${estrattoConto.value.id}`})
          } else {
            toast.add({severity:'warn',summary: 'Errore', detail:'Problemi nell\'operazione', life: 3000});
          }

        })
      }

      const openEditDialog = (data) => { 
        oldPayment.value = ''
        newNumero.value = ''
        editDialog.value = true
        oldPayment.value = data
      }

      const substitute = () => {
        submitted.value = true
        if (validateForm()) {
          service.substituteNumberInvoice(newNumero.value, oldPayment.value).then((res) => {
            if (res) {
              // getInfo().then(() =>{
              //   editDialog.value = false
              // })
              fatture.value.map(function(item) {
                item.edit = false
                if (item.numero == oldPayment.value.numero) {
                  item.edit = true
                  item.numero = newNumero.value
                  editDialog.value = false
                }
              });
            }
          })
        } 
      }

      const rowClass = (data) => {
          return data.edit == true ? 'row-bg': null;
      };

      const validateForm = () => {
        if (newNumero.value.length > 5)
            delete validationErrors.value['numero'];
        else 
            validationErrors.value['numero'] = true;

        return !Object.keys(validationErrors.value).length;
      }

      const formatCurrency = (value) => {
        value = parseFloat(value)
        return value.toLocaleString('it-IT')
      };

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      return {
        dt,
        exportCSV,
        estrattoConto,
        confirmDissociate,
        fatture,
        fornitori,
        display,
        dissociateDialog,
        editDialog,
        openEditDialog,
        dissociate,
        oldPayment,
        newNumero,
        substitute,
        formatCurrency,
        formatDate,
        loader,
        rowClass,
        submitted,
        validationErrors
      }
    

    }
}
</script>

<style scoped>
.importo {
  font-size: 3.5rem;
  color: var(--blue-500);
}

.title-detail {
  font-size: 10px;
  letter-spacing: 2px;
}
.warn-not-regularized {
  width: 100%;
  background-color: rgb(247, 201, 53);
}


:deep(.row-bg) {
    animation-name: bg-change;
    animation-duration: 4s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;    
    animation-play-state: running;
    background-color: rgba(110, 248, 76, 0.916);
}


@keyframes bg-change {
    0%     {background-color:rgba(110, 248, 76, 0.779);}
    50.0%  {background-color:rgba(110, 248, 76, 0.618);}
    100.0%  {background-color:none;}
}


</style>

